( function ( $ ) {
	$( document ).ready( function () {
		function getProductData( source, name ) {
			const newName = name.toUpperCase();

			const results = $.map( source, function ( entry ) {
				const match =
					entry.slug.toUpperCase().indexOf( newName ) !== -1;
				return match ? entry : null;
			} );

			return results[ 0 ];
		}

		function createComparisonTable() {
			const $button = $( '.hh-ct-cat-selector button.active' );
			const $target = $( '#' + $button.attr( 'data-target' ) );

			const $filters = $( JSON.parse( $button.attr( 'data-group' ) ) );
			const $productOne = getProductData(
				$products_data,
				$target.find( '.compare-dropdown-0' ).val()
			);
			const $productTwo = getProductData(
				$products_data,
				$target.find( '.compare-dropdown-1' ).val()
			);
			let $html = '';

			$.each( $filters, function ( index, value ) {
				if( $productOne.sections[ value ] || $productTwo.sections[ value ] ) {
					$html +=
						'<div class="hh-ct-row" data-id="' +
						value.toLowerCase() +
						'"><div class="hh-ct-rowheader hh-ct-rowheader-style">';
					$html += value + '</div>';
					$html +=
						'<div class="hh-ct-cell">' + $productOne.sections[ value ];
					$html += '</div>';
					$html +=
						'<div class="hh-ct-cell">' + $productTwo.sections[ value ];
					$html += '</div>';
					$html += '</div>';
				}
			} );

			$( '#comparing-items' ).html( $html );
		}

		const $buttons = $( '.hh-ct-cat-selector button' );

		if ( $buttons.length ) {
			$( '.hh-ct-cat-selector button' ).on( 'click', function () {
				const $this = $( this );
				const $target = $( '#' + $this.attr( 'data-target' ) );

				$( '.hh-ct-row-picker' ).addClass( 'hidden' );

				$target.removeClass( 'hidden' );

				$buttons
					.removeClass( 'active' )
					.addClass( 'button-outline-blue' );

				$this.addClass( 'active' ).removeClass( 'button-outline-blue' );

				createComparisonTable();
			} );

			$( '.selector-dropdown' ).on( 'change', function () {
				createComparisonTable();
			} );

			createComparisonTable();
		}
	} );
} )( jQuery );
